import { APP_VARIANT } from "../../config/setting";
import { AvailableAppVariants } from "../enums";
import { APP_CONFIG } from "./themeConfig";

/**
 * @WHITE_LABEL_CHANGES
 */
const themeAssets = APP_CONFIG?.[APP_VARIANT]?.assets ?? APP_CONFIG[AvailableAppVariants.PulseEnergyLite].assets;

export const THEME_ASSETS = {
    FullLogoVector: themeAssets.FullLogoVector,
    FullLogoUrl: themeAssets.FullLogoUrl,
    SearchingRipple: themeAssets.SearchingRipple,
    Check: themeAssets.Check,
};
